"use client";
import React from "react";
import { GoArrowLeft } from "react-icons/go";
import { usePathname } from "next/navigation";

const t = {
  "en-us": {
    title: "Something's missing.",
    body: "Something is wrong here. It seems like what you are looking for cannot be found.",
    back: "Back to home",
  },
  "es-es": {
    title: "Algo falta.",
    body: "Algo está mal aquí. Parece que lo que estás buscando no se puede encontrar.",
    back: "Volver al inicio",
  },
};

const getLang = (pathname = "/") => {
  //   if (pathname?.startsWith("/es")) return "es-es";
  //   if (pathname?.startsWith("/ru")) return "ru-ru";
  return "en-us";
};

export default function NotFound() {
  const pathname = usePathname();
  const lang = getLang(pathname);

  const copy = t[lang];

  return (
    <div>
      <h3 className="title-xl title-font mb-[12px]">{copy.title}</h3>
      <div className="text-base mb-[18px] md:mb-[24px]">{copy.body}</div>
      <div>
        <a
          href={lang === "es-es" ? "/es" : "/"}
          className="flex cursor-pointer btn btn-secondary"
        >
          <div className="flex items-center">
            <GoArrowLeft size={20} />
            <span className={"ms-2"}>{copy.back}</span>
          </div>
        </a>
      </div>
    </div>
  );
}
